import { cn } from "@/lib/utils";
import { motion } from "framer-motion";

const RGB_BRAND_GRAY_100 = "197, 199, 202";
const RGB_BRAND_HIGHLIGHT = "56, 189, 248";
const RGB_BRAND_WARNING = "206, 155, 56";
const RGB_BRAND_ERROR = "192, 63, 70";

enum Color {
  default = RGB_BRAND_GRAY_100,
  highlight = RGB_BRAND_HIGHLIGHT,
  warning = RGB_BRAND_WARNING,
  error = RGB_BRAND_ERROR
}

interface Props {
  type?: "default" | "highlight" | "warning" | "error";
  className?: string;
}

export const LoadingCircle = ({ type = "default", className }: Props) => {
  return (
    <div
      className={cn(
        "relative flex items-center justify-center p-1.5 flex-shrink-0",
        className
      )}
      style={{
        width: "18px",
        height: "18px"
      }}
      data-testid="loadingCircle"
    >
      <div
        className="relative w-full rounded-full h-full"
        style={{ backgroundColor: `rgb(${Color[type]})` }}
      />
      <motion.div
        className="absolute inset-0 rounded-full"
        style={{
          borderRadius: "100%",
          padding: "2px",
          background: `conic-gradient(rgba(${Color[type]}, 1) 0deg, rgba(${Color[type]}, 1) 90deg, rgba(${Color[type]}, 0.5) 90deg, rgba(${Color[type]}, 0.5) 360deg)`,
          mask: "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
          maskComposite: "exclude"
        }}
        initial={{ rotate: "0deg" }}
        animate={{ rotate: "360deg" }}
        transition={{ duration: 0.6, repeat: Infinity, ease: "linear" }}
      />
    </div>
  );
};
